import type { RootState } from "infrastructure/store";
import { ApiState } from "infrastructure/api";
import { MenuItem } from "consts/waMessaging";

export const selectIsWaMessagingResourceUninitialized = (menuItem: MenuItem) =>
    (state: RootState) =>
        state.waMessaging[menuItem].tableLoadingState === ApiState.Idle;

export const selectIsWaMessagingResourceLoading = (menuItem: MenuItem) =>
    (state: RootState) =>
        state.waMessaging[menuItem].tableLoadingState === ApiState.Pending;

export const selectIsExportWaMessagingResourceLoading = (menuItem: MenuItem) =>
    (state: RootState) =>
        state.waMessaging[menuItem].exportLoadingState === ApiState.Pending;

export const selectWaMessagingResourceSlice = (menuItem: MenuItem) =>
    (state: RootState) =>
        state.waMessaging[menuItem].tableSlice;
